export const AD_LOADED_ATTRIBUTE = 'data-aller-ad-loaded';

export const AD_PLACEMENT_ATTRIBUTE = 'data-aller-ad-placement';

export const setAdLoadedForDiv = (divId: string) => {
  document.getElementById(divId).setAttribute(AD_LOADED_ATTRIBUTE,'');  
};

export const setAdLoadedForElement = (div: HTMLElement) => {
  div.setAttribute(AD_LOADED_ATTRIBUTE,'');
};


